import React from 'react'
import { Spinner, Text } from '@vtex/shoreline'

import * as S from './styles'

interface LoadingSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string
  padding?: string
}

export const LoadingSection = ({
  text,
  padding,
  ...rest
}: LoadingSectionProps) => {
  return (
    <S.Container align="center" direction="column" padding={padding} {...rest}>
      <Spinner />
      <Text variant="action" color="var(--sl-fg-base)">
        {text}
      </Text>
    </S.Container>
  )
}
